export const locale = {
    lang: 'pl',
    data: {
        "Notes": "Notatki",
        "Add note": "Dodaj notatkę",
        "by": "przez",
        "Created": "Utworzone",
        "Description": "Treść",
    }
};
